import script from "./PortfolioView.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioView.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioView.vue?vue&type=style&index=0&id=522ffa67&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-522ffa67"]])

export default __exports__